import React, { useState, useEffect } from "react";
import { Container } from "./styles";
import MetricChart from "./metricChart";
import { monitorCenterAPI } from "api";

const RoundToTwo = (val) => Number(val.toFixed(2));

const MergeMetricsData = (rawData) => {
  const timestamps = rawData.cpu.map(([t]) => t);
  const FormatTime = (t) => {
    const date = new Date(t * 1000);
    const y = String(date.getFullYear()).slice(2);
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    const h = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");
    return `${y}-${m}-${d} ${h}:${min}`;
  };

  return timestamps.map((t, idx) => ({
    time: FormatTime(t),
    cpu: RoundToTwo(Number(rawData.cpu?.[idx]?.[1] ?? 0)),
    ram: RoundToTwo(Number(rawData.ram?.[idx]?.[1] ?? 0)),
    gpu: RoundToTwo(Number(rawData.gpu?.[idx]?.[1] ?? 0)),
    vram: RoundToTwo(Number(rawData.vram?.[idx]?.[1] ?? 0)),
    xidle: RoundToTwo(Number(rawData.xidle?.[idx]?.[1] ?? 0)),
  }));
};

const UtilizationPanel = ({ selectedNode, start, end }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const FetchData = async () => {
      if (start !== "" && end !== "" && start !== end) {
        const apiData = await monitorCenterAPI.metricRange(
          selectedNode,
          start,
          end
        );
        setData(MergeMetricsData(apiData.data));
      } else {
        setData(null);
      }
    };
    FetchData();
  }, [selectedNode, start, end]);

  if (!data) return null;

  return (
    <Container>
      <MetricChart title="Time Graph" data={data} />
    </Container>
  );
};

export default UtilizationPanel;
